import React from "react";
import { useTheme } from "@mui/material/styles";

export default function CustomPagination({
  totalPages,
  currentPage,
  onPageChange,
}) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const generatePages = () => {
    let pages = [];

    if (totalPages <= 6) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages = [1, 2, 3, "...", totalPages - 1, totalPages];
    }

    return pages;
  };

  const pages = generatePages();

  return (
    <div
      style={{
        display: "flex",
        gap: "8px",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "30px",
        flexWrap: "wrap",
      }}
    >
      {/* Previous Button */}
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        style={{
          ...styles.arrowBtn,
          background: isDark ? "#111" : "#fff",
          color: isDark ? "#fff" : "#000",
          borderColor: isDark ? "#333" : "#e5e5e5",
        }}
      >
        ⟵
      </button>

      {/* Page Numbers */}
      {pages.map((p, i) => (
        <button
          key={i}
          onClick={() => p !== "..." && onPageChange(p)}
          disabled={p === "..."}
          style={{
            ...styles.pageBtn,
            background:
              currentPage === p
                ? "#ff1850"
                : isDark
                ? "#111"
                : "#fff",
            color:
              currentPage === p
                ? "#fff"
                : isDark
                ? "#fff"
                : "#000",
            borderColor: isDark ? "#333" : "#e5e5e5",
            cursor: p === "..." ? "default" : "pointer",
          }}
        >
          {p}
        </button>
      ))}

      {/* Next Button */}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        style={{
          ...styles.arrowBtn,
          background: isDark ? "#111" : "#fff",
          color: isDark ? "#fff" : "#000",
          borderColor: isDark ? "#333" : "#e5e5e5",
        }}
      >
        ⟶
      </button>
    </div>
  );
}

const styles = {
  pageBtn: {
    padding: "8px 14px",
    borderRadius: "10px",
    border: "1px solid #e5e5e5",
    fontWeight: "600",
    fontSize: "14px",
    transition: "0.2s",
  },
  arrowBtn: {
    padding: "8px 12px",
    borderRadius: "10px",
    border: "1px solid #e5e5e5",
    fontSize: "16px",
    cursor: "pointer",
    transition: "0.2s",
  },
};
